export const getUnmaskedPhone = (value: string): string => value.replace(/[\s()_+]/g, '');

export const getPhoneString = (value: string): string => `+${getUnmaskedPhone(value)}`;

export const getMaskedPhone = (value: string): string =>
	`+${value.slice(0, 2)} (${value.slice(2, 5)}) ${value.slice(5, 8)} ${value.slice(8, 10)} ${value.slice(10)}`;

export const getPhoneWithUACode = (phone: string) => {
	const unmasked = getUnmaskedPhone(phone);

	return unmasked.startsWith('38') ? unmasked : `38${phone}`;
};
